import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { Header } from 'components';
import './Main.css';
import '../responsive.css';

class Main extends Component {
  render() {
    return (
      <div className="main responsive__layout">
        <Header />
        <div className="responsive__content">
          { this.props.children }
        </div>
      </div>
    );
  }
}

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/layouts/Main/Main.js